import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { colorBlue, colorLightBlue } from "../../../../../../utils/palette";
import defaultPartIcon from "@/shared/img/default/default_parts.png";
import { s3Url } from "../../../../../constants";
import { StatusContainer } from "../../../../TableElements";

const UsageInfoComponent = ({ rowData }) => {
  const { t } = useTranslation("common");
  const { orgId } = useSelector((state) => state.user);
  const { part_name, location, image, part_id, category_name } = rowData;
  const partImg = image
    ? `${s3Url}/org_${orgId}/parts/${part_id}/${image}`
    : "";
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-2 align-items-center py-2">
          <div
            style={{
              border: `1px solid ${colorBlue}`,
              borderRadius: "20px",
              width: 40,
              height: 40,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={partImg || defaultPartIcon}
              alt="part-img"
              style={{ width: "40px", height: "40px" }}
              className="rounded-circle"
            />
          </div>
          <div style={{ overflow: "auto" }}>
            <p style={{ fontSize: "14px", fontWeight: 500 }}>{part_name}</p>
            <p style={{ fontSize: "12px" }}>{location}</p>
          </div>
        </div>
        {category_name && (
          <div>
            <StatusContainer background={"#eff6ff"}>
              <p style={{ color: "#1447e6" }}>{category_name}</p>
            </StatusContainer>
          </div>
        )}
      </div>
    </>
  );
};

export default UsageInfoComponent;
